import { areFieldsSet } from '@superbet-group/web.lib.utilities';
import { BetTypeEvent } from '@core/mappers/bonus/dtos/BetEligibilityDto';
import OfferEventsOdds from '@models/bonus/OfferEventsOdds';

export function transformEventOdds(dto: BetTypeEvent): OfferEventsOdds {
    return {
        id: dto.ExternalBetTypeId,
        name: dto.BetTypeName,

        ...areFieldsSet(dto, 'MinimumPrice') && { minOdd: dto.MinimumPrice },
    };
}
